import { THEME } from '../../../../web/components-v2/Theme/theme';

export const ticketTopBarStyles = {
	// Compact variant for embedding the bar inline in the inbox masthead: no band
	// background/border/min-height, just an inline flex row that stretches to fill the
	// space between the mailbox switcher and the user profile.
	topBarInline: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 16,
		flex: 1,
		minWidth: 0,
	},
	topBarLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		flex: '1 1 auto',
		minWidth: 0,
	},
	ticketNumber: {
		fontSize: 13,
		color: THEME.colors.text.light,
	},
	ticketSubject: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	aiScoreBadge: {
		display: 'inline-block',
		padding: '2px 8px',
		borderRadius: 12,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	aiScoreGreen: { backgroundColor: THEME.colors.success.light, color: THEME.colors.success.dark },
	aiScoreYellow: { backgroundColor: THEME.colors.info.light, color: THEME.colors.warning.dark },
	aiScoreRed: { backgroundColor: THEME.colors.danger.light, color: THEME.colors.danger.dark },
	categoryPicker: {
		display: 'inline-flex',
		justifyContent: 'flex-end',
		minWidth: 0,
	},
	categoryPickerTrigger: {
		height: 36,
		maxWidth: 220,
		minWidth: 0,
		backgroundColor: THEME.colors.background.light,
	},
	categoryPickerDropdown: {
		width: 'min(max(var(--anchor-width), 260px), var(--available-width))',
		minWidth: 'min(max(var(--anchor-width), 260px), var(--available-width))',
	},
	categoryPickerSearchWrapper: {
		padding: THEME.spacing.sm,
		paddingBottom: THEME.spacing.xs,
	},
	categoryPickerList: {
		maxHeight: 240,
		overflowY: 'auto' as const,
		...THEME.common.scrollBar,
	},
	categoryPickerValue: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		maxWidth: '100%',
		minWidth: 0,
		...THEME.common.truncate,
	},
	categoryPickerSwatch: {
		display: 'inline-block',
		width: THEME.spacing.sm,
		height: THEME.spacing.sm,
		borderRadius: '50%',
		flexShrink: 0,
	},
	categoryPickerName: {
		minWidth: 0,
		...THEME.common.truncate,
	},
	topBarActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		flex: 'none',
		marginLeft: 'auto',
		marginRight: 8,
	},
	actionIconBtn: {
		width: 36,
		height: 36,
		padding: 0,
		borderRadius: 10,
		'@media (max-width: 767px)': { width: 44, height: 44 },
	},
	actionIconBtnActive: {
		borderColor: THEME.colors.primary.main,
		color: THEME.colors.primary.main,
		backgroundColor: THEME.colors.primary.light,
	},
	actionPrimaryBtn: {
		height: 36,
	},
	topBarTitleRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		minWidth: 0,
	},
} as const;
